/**
 * Created by florinia on 09/10/2017.
 */
import ExternalLinksBaseHandler from '../external_links_base_handler';
import * as EXTERNAL_LINKS_CONSTS from '../../external_links_consts';
import {PRODUCT_PACKAGE_MAP} from '../external_links_base_handler_consts';
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";

const RICH_POST_ACTIONS = {
    OPEN_REAL_GAME: '1',
    OPEN_ANONYMOUS_GAME: '36',
    CASHIER: '6',
	SPORT: '24',
    EXTERNAL_URL: '27',
    REMOVE_INDICATION: '64',
};

class ExternalLinksRichHandler extends ExternalLinksBaseHandler {
    static CLASS = 'ExternalLinksRichHandler';
    static HandlerName = 'rich';


	getAcceptedSourcesMap() {
		return [
			PRODUCT_PACKAGE_MAP.RICH_PP_ID
		];
	}


    /**
     * Overrides base class
     * @param postMessageData
     */
	executePostMessageAction(postMessageData) {
        switch (postMessageData.ActionId.toString()) {
            case RICH_POST_ACTIONS.EXTERNAL_URL:
                this.close();
                this._serviceFactory.windowService().redirect(postMessageData.Url);
                break;
            case RICH_POST_ACTIONS.CASHIER:
                this.openCashier(postMessageData);
                break;
            case RICH_POST_ACTIONS.OPEN_REAL_GAME:
                this.openRealGame(postMessageData.GameId);
                break;
            case RICH_POST_ACTIONS.OPEN_ANONYMOUS_GAME:
                this.openAnonymousGame(postMessageData.GameId);
                break;
			case RICH_POST_ACTIONS.SPORT:
				this.close();
				this.openExternalLink({
					source: EXTERNAL_LINKS_CONSTS.GNWP_SOURCES.SPORT
				});
				break;
            case RICH_POST_ACTIONS.REMOVE_INDICATION:
                Event.fire(SYSTEM_EVENTS.DAILY_DEAL_REMOVE_INDICATION);
                break;
            default:
                // maybe should throw an Exception here
                break;
        }
    }

}

export default ExternalLinksRichHandler;